export enum AppRouteNames {
  ExistingUserRegistration = "existing-user-registration",
  InvitedUserRegistration = "invited-user-registration",
  NotFound = "not-found",
  UserRegistration = "user-registration",
  VerifyEmail = "verify-email",
}
